<template>
  <div>SharingTab</div>
</template>
